(function () {
  'use strict';

  /* NAV SCROLL */
  const nav = document.getElementById('mainNav');
  if (nav) {
    // Force scrolled state on all pages without a dark hero video
    if (!document.getElementById('scrollHeroSection')) {
      nav.classList.add('scrolled');
    }
    window.addEventListener('scroll', () => {
      nav.classList.toggle('scrolled', window.scrollY > 50);
    }, { passive: true });
  }

  /* SCROLL REVEAL */
  const revealEls = document.querySelectorAll('.reveal');
  if (revealEls.length) {
    const revealObs = new IntersectionObserver((entries) => {
      entries.forEach(e => {
        if (e.isIntersecting) {
          e.target.classList.add('visible');
          revealObs.unobserve(e.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    revealEls.forEach(el => revealObs.observe(el));
  }

  /* MOBILE NAV */
  const menuBtn = document.getElementById('navMenuBtn');
  const overlay = document.getElementById('mobileNavOverlay');
  const panel = document.getElementById('mobileNavPanel');
  const closeBtn = document.getElementById('mobileNavClose');

  function openMobileNav() {
    overlay.classList.add('open');
    panel.classList.add('open');
    document.body.style.overflow = 'hidden';
  }
  function closeMobileNav() {
    overlay.classList.remove('open');
    panel.classList.remove('open');
    document.body.style.overflow = '';
  }

  if (menuBtn) menuBtn.addEventListener('click', openMobileNav);
  if (closeBtn) closeBtn.addEventListener('click', closeMobileNav);
  if (overlay) overlay.addEventListener('click', (e) => {
    if (e.target === overlay) closeMobileNav();
  });

  /* QUANTITY SELECTOR (homepage featured product) */
  let qty = 1;
  const qtyNum = document.getElementById('qtyNum');
  const qtyMinus = document.getElementById('qtyMinus');
  const qtyPlus = document.getElementById('qtyPlus');
  const qtyInput = document.getElementById('productQtyInput');
  const buyNowQtyInput = document.getElementById('buyNowQtyInput');

  function syncQty(val) {
    if (qtyInput) qtyInput.value = val;
    if (buyNowQtyInput) buyNowQtyInput.value = val;
  }

  if (qtyMinus && qtyPlus && qtyNum) {
    qtyMinus.addEventListener('click', () => {
      if (qty > 1) { qty--; qtyNum.textContent = qty; syncQty(qty); }
    });
    qtyPlus.addEventListener('click', () => {
      if (qty < 10) { qty++; qtyNum.textContent = qty; syncQty(qty); }
    });
  }

  /* SHOPIFY CART FORM SUBMIT — sync qty */
  const productForm = document.getElementById('clyr-product-form');
  if (productForm) {
    productForm.addEventListener('submit', function () {
      if (qtyInput) qtyInput.value = qty;
    });
  }

  /* BEFORE / AFTER SLIDER */
  const slider = document.getElementById('comparisonSlider');
  if (slider) {
    const afterEl = document.getElementById('comparisonAfter');
    const dividerEl = document.getElementById('compDivider');
    const handleEl = document.getElementById('compHandle');
    let isDragging = false;

    function setPosition(x) {
      const rect = slider.getBoundingClientRect();
      let pct = ((x - rect.left) / rect.width) * 100;
      pct = Math.max(5, Math.min(95, pct));
      if (afterEl) afterEl.style.clipPath = `inset(0 ${100 - pct}% 0 0)`;
      if (dividerEl) dividerEl.style.left = pct + '%';
      if (handleEl) handleEl.style.left = pct + '%';
    }

    slider.addEventListener('mousedown', (e) => { isDragging = true; setPosition(e.clientX); });
    window.addEventListener('mousemove', (e) => { if (isDragging) setPosition(e.clientX); });
    window.addEventListener('mouseup', () => { isDragging = false; });
    slider.addEventListener('touchstart', (e) => { isDragging = true; setPosition(e.touches[0].clientX); }, { passive: true });
    window.addEventListener('touchmove', (e) => { if (isDragging) setPosition(e.touches[0].clientX); }, { passive: true });
    window.addEventListener('touchend', () => { isDragging = false; });
  }

  /* STICKY BAR SHOW/HIDE */
  const purchaseSection = document.getElementById('purchase');
  const stickyBar = document.getElementById('stickyBar');
  if (purchaseSection && stickyBar && window.innerWidth < 769) {
    const barObs = new IntersectionObserver((entries) => {
      entries.forEach(e => {
        stickyBar.style.display = e.isIntersecting ? 'none' : 'flex';
      });
    }, { threshold: 0.1 });
    barObs.observe(purchaseSection);
  }

  /* STICKY BAR PRICE SYNC */
  if (stickyBar) {
    const mainPrice = document.getElementById('productPrice');
    const barPrice = document.getElementById('stickyPrice');
    if (mainPrice && barPrice) {
      barPrice.textContent = mainPrice.textContent;
    }
  }

  /* SMOOTH SCROLL FOR ANCHOR LINKS */
  document.querySelectorAll('a[href^="#"]').forEach(a => {
    a.addEventListener('click', (e) => {
      const target = document.querySelector(a.getAttribute('href'));
      if (target) {
        e.preventDefault();
        const offset = (nav ? nav.offsetHeight : 0) + 20;
        window.scrollTo({ top: target.offsetTop - offset, behavior: 'smooth' });
      }
    });
  });

  /* PRODUCT PAGE GALLERY THUMBNAILS */
  document.querySelectorAll('.gallery-thumb').forEach(thumb => {
    thumb.addEventListener('click', function () {
      const mainImg = document.getElementById('galleryMain');
      if (mainImg && this.dataset.src) {
        mainImg.src = this.dataset.src;
        document.querySelectorAll('.gallery-thumb').forEach(t => t.classList.remove('active'));
        this.classList.add('active');
      }
    });
  });

  /* CART QUANTITY UPDATE */
  document.querySelectorAll('.cart-qty-input').forEach(input => {
    input.addEventListener('change', function () {
      const min = parseInt(this.min) || 1;
      const max = parseInt(this.max) || 99;
      let val = parseInt(this.value) || 1;
      this.value = Math.max(min, Math.min(max, val));
    });
  });

})();
